<script lang="ts" setup>
import '~/node_modules/@skillstown/leap/dist/style.css';
import '~/node_modules/@vueup/vue-quill/dist/vue-quill.snow.prod.css'
import '~/node_modules/@vuepic/vue-datepicker/dist/main.css';
import { useSnackbar } from './stores/snackbar';
import { useConfiguration } from '@/composables/useConfigration';
import { useModal } from './stores/modal';
import { useSessionTimeout } from './stores/sessionTimeout';
import { useDrawer } from './stores/drawer';

const route = useRoute();
const snackbar = useSnackbar();
const modal = useModal();
const drawer = useDrawer();
const isSnackbarVisible = computed(() => snackbar.active);
const sessionTimeout = useSessionTimeout();
const configuration = ref(useConfiguration());
const isAdminRoute = computed(() => route.fullPath.includes('admin'));
useTagManager();
</script>

<template>
  <div class="triple-a-app">
    <NuxtLoadingIndicator color="#5B40BF" :height="2" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <BaseSnackbar v-if="isSnackbarVisible" />
    <ModalServiceContainer v-if="modal.isOpen" />
    <Transition name="fade">
      <DrawerServiceContainer v-if="drawer.isOpen" />
    </Transition>
    <FaqFixedIcons v-if="!isAdminRoute" />
  </div>
</template>

<style lang="postcss">
.triple-a-app {
  @apply relative;
}

.page-enter-active,
.page-leave-active {
  transition: all 0.15s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}

body {
  background-color: var(--color-background);
}

:root {
  --size-1: 4px;
  --size-2: 8px;
  --size-3: 12px;
  --size-4: 16px;
  --size-5: 20px;
  --size-6: 24px;
  --size-7: 32px;
  --size-8: 40px;
  --size-8: 48px;
  --size-9: 64px;
}

.fade-enter-active {
  transition: all 0.2s ease-out;
}

.fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.ql-container,
.ql-editor {
  font-family: 'PT Sans', sans-serif !important;
  font-size: 14px;
}

.pe-status-label {
  color: white;

  &--green {
    background-color: var(--color-green);
  }

  &--orange {
    background-color: var(--color-orange);
  }

  &--red {
    background-color: var(--color-red);
  }

  &--grey {
    background-color: var(--color-grey-medium);
  }
}

.button .button__text {
  padding-inline: 0px;

}




.ql-editor .ql-align-center img {
  display: inline;
}

.ql-editor .ql-align-left img {
  display: inline;
}

.ql-editor .ql-align-right img {
  display: inline;
}




.ql-editor .ql-indent-1 {
  padding-left: unset !important;
  max-width: 95%;
  margin: 0 auto;
}

.ql-editor .ql-indent-2 {
  padding-left: unset !important;
  max-width: 90%;
  margin: 0 auto;
}

.ql-editor .ql-indent-3 {
  padding-left: unset !important;
  max-width: 85%;
  margin: 0 auto;
}

.ql-editor .ql-indent-4 {
  padding-left: unset !important;
  max-width: 80%;
  margin: 0 auto;
}

.ql-editor .ql-indent-5 {
  padding-left: unset !important;
  max-width: 75%;
  margin: 0 auto;
}

.ql-editor .ql-indent-5 {
  padding-left: unset !important;
  max-width: 70%;
  margin: 0 auto;
}

.modal-container {
  z-index: 40;
}

.btn-white {
  background-color: white !important;
  color: var(--color-brand) !important;
}

.btn-white:hover {
  color: rgb(113, 82, 228) !important
}

.btn-outline {
  color: white !important;
  box-shadow: none;
  border: 1px solid white;
  background-color: transparent;
}

.btn-outline:hover {
  background-color: #4327a6 !important;
}

.btn-outline-delete {
  color: #ef4444 !important;
  box-shadow: none;
  border: 1px solid #ef4444;
  background-color: transparent;
}

.btn-outline-delete:hover {
  background-color: #4327a6 !important;
}

.btn-menu .popover__trigger svg {
  color: white !important;
}

.btn-menu:hover {
  background-color: #4327a6 !important;
  border-radius: 5px;
}

.btn-menu .button-variant--flat {
  background-color: #4327a6 !important;
  border-radius: 5px;
}

.btn-menu .popover__trigger:hover {
  background-color: #4327a6 !important;
  border-radius: 5px;
}

.popper {
  padding: 0px !important;
}

.results {
  @apply text-gray-300;
}
</style>
